import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../styles/RouteMap.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const createCustomIcon = (type) => {
  const colors = {
    drinking_water: '#1e90ff',
    shelter: '#ff6347',
    viewpoint: '#32cd32',
    restaurant: '#ffa500',
    cafe: '#d2691e',
    parking: '#808080',
    toilets: '#9370db',
    spring: '#00bfff',
    bicycle: '#ff1493',
    default: '#667eea',
  };

  const color = colors[type] || colors.default;

  return L.divIcon({
    className: 'custom-marker',
    html: `
      <div style="
        background-color: ${color};
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 3px solid white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      "></div>
    `,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
};

const RouteMap = ({ coordinates, pois, stravaSegments }) => {
  const mapRef = useRef();
  const routeCoords = coordinates.map((coord) => [coord.lat, coord.lon]);
  const center = routeCoords.length > 0 ? routeCoords[Math.floor(routeCoords.length / 2)] : [41.3851, 2.1734];

  useEffect(() => {
    if (mapRef.current && routeCoords.length > 0) {
      const bounds = L.latLngBounds(routeCoords);
      mapRef.current.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [routeCoords]);

  useEffect(() => {
    console.log('🗺️ RouteMap renderitzat');
    console.log('📍 Coordenades ruta:', routeCoords.length);
    console.log('📌 POIs:', pois?.length || 0);
    console.log('🏃 Segments Strava:', stravaSegments?.length || 0);
  }, [routeCoords, pois, stravaSegments]);

  return (
    <div className="route-map-container fade-in">
      <MapContainer center={center} zoom={13} ref={mapRef} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Ruta principal */}
        <Polyline positions={routeCoords} color="#667eea" weight={4} opacity={0.8} />

        {/* Marcadors inici/final */}
        {routeCoords.length > 0 && (
          <>
            <Marker position={routeCoords[0]}>
              <Popup><strong>🏁 Inici de la ruta</strong></Popup>
            </Marker>
            <Marker position={routeCoords[routeCoords.length - 1]}>
              <Popup><strong>🏁 Final de la ruta</strong></Popup>
            </Marker>
          </>
        )}

        {/* SEGMENTS STRAVA - SOBRE LA RUTA */}
        {stravaSegments && stravaSegments.length > 0 && (
          <>
            {console.log('🔍 Pintant segments Strava:', stravaSegments.length)}
            {stravaSegments.slice(0, 10).map((segment, index) => {
              if (!segment.start_lat || !segment.end_lat) {
                console.warn('⚠️ Segment sense coordenades:', segment);
                return null;
              }
              
              const positions = [
                [segment.start_lat, segment.start_lon],
                [segment.end_lat, segment.end_lon]
              ];
              
              console.log(`📍 Segment ${index + 1}: ${segment.name}`, positions);
              
              return (
                <Polyline
                  key={`strava-${segment.id || index}`}
                  positions={positions}
                  pathOptions={{
                    color: '#fc4c02',
                    weight: 6,
                    opacity: 0.9,
                    dashArray: '15, 10'
                  }}
                >
                  <Popup>
                    <div className="strava-popup">
                      <strong>🏃 {segment.name}</strong>
                      <p>📏 Distància: {segment.distance.toFixed(0)}m</p>
                      <p>📈 Pendent: {segment.avg_grade.toFixed(1)}%</p>
                      <p>⛰️ Desnivell: {segment.elev_difference.toFixed(0)}m</p>
                      <p>👥 Intents: {segment.effort_count}</p>
                    </div>
                  </Popup>
                </Polyline>
              );
            })}
          </>
        )}

        {/* POIs */}
        {pois && pois.map((poi, index) => (
          <Marker
            key={`poi-${index}`}
            position={[poi.lat, poi.lon]}
            icon={createCustomIcon(poi.type)}
          >
            <Popup>
              <div className="poi-popup">
                <strong>{poi.name}</strong>
                <p>Tipus: {poi.type}</p>
                {poi.distance_from_start && <p>KM: {poi.distance_from_start.toFixed(1)}</p>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      <div className="map-legend">
        <div className="legend-item">
          <div className="legend-line route-line"></div>
          <span>Ruta</span>
        </div>
        {stravaSegments && stravaSegments.length > 0 && (
          <div className="legend-item">
            <div className="legend-line strava-line"></div>
            <span>Segments Strava ({stravaSegments.length})</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RouteMap;